$(document).ready(function () {


    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });

});

 $(document).on("click", ".hk-play-button", function (e) {
     var video = jQuery(this).parents('.hk-video-wrapper').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.hk-video-wrapper').removeClass('active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.hk-video-wrapper').addClass('active');
     jQuery(this).addClass('active');
 }
 });



 
jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

$(window).on('scroll', function () {
  let scrollTop = $(this).scrollTop();

  if (scrollTop > 30) {
    $('body').addClass('remove_transparent');
  } else {
    $('body').removeClass('remove_transparent');
  }
});



$(document).on("click", ".hk-question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.hk-question').removeClass('active');
    jQuery('.hk-question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});

$(document).on("click", ".hk-drawer-menu-inner a.hk-parent-link", function (e) {
  e.preventDefault();
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.hk-drawer-menu-inner a.hk-parent-link').removeClass('active');
    jQuery('.hk-drawer-menu-inner a.hk-parent-link').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", "a[href='/#faq']", function (e) {
  const target = document.querySelector('.hk-faq');

  if (target) {
    e.preventDefault();
    target.scrollIntoView({
      behavior: 'smooth'
    });
  }
  // else: do nothing → browser follows the link normally
});
$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.hk-element-sub-option').scrollIntoView({
    behavior: 'smooth'
  })
});


$(document).on("click", ".hk-mobile-menu-button", function (e) {
    $('.hk-drawer-menu').addClass('active');
    $('.hk-drawer-menu-bg').show();
    $('body').addClass('hk-overflow-hidden');
});
$(document).on("click", ".hk-mobile-menu-close", function (e) {
    $('.hk-drawer-menu').removeClass('active');
    $('.hk-drawer-menu-bg').hide();
    $('body').removeClass('hk-overflow-hidden');
});

$(document).on("click", ".hk-drawer-menu-bg", function (e) {
    $('.hk-drawer-menu').removeClass('active');
    $('.hk-drawer-menu-bg').hide();
    $('body').removeClass('hk-overflow-hidden');
});




$(document).on("click", ".hk-element-option", function(e) {
$(this).parents('.hk-product').find('.hk-element-option').removeClass('active');
$(this).addClass('active');
var data_tab = $(this).attr('data_tab');
$(this).parents('.hk-product').find('.hk-quantity-data').hide();
$(this).parents('.hk-product').find('.hk-quantity-data[data_tab="'+data_tab+'"]').show();
});


$(document).on("click", ".hk-element-sub-option", function(e) {
$(this).toggleClass('hk-active');
hkRefreshPrices();
});











$(document).on("click", ".hk-cart-button", function (e) {
document.querySelector('cart-drawer')?.open();
});






 $(document).on("click", '.hk-atc-js', function (e) {
  e.preventDefault();
  var $btn = $(this);
  // prevent multiple clicks
  if ($btn.hasClass('hk-loading')) return;

  $btn.addClass('hk-loading');
  var items = [];
  // main product
  var variant_id = $btn.attr('variant_id');
  var selling_plan = $btn.attr('selling_plan');
  var item = {
    id: parseInt(variant_id),
    quantity: 1
  };

  // add selling plan if exists
  if (selling_plan) {
    item.selling_plan = parseInt(selling_plan);
  }

  items.push(item);

  // subscription (only if checked) — added once
  var subItem = hkGetSubItem();
  if (subItem) items.push(subItem);

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({
      items: items
    }),
    dataType: 'json',
    contentType: 'application/json',

    success: function () {


    },

    complete: function () {
      setTimeout(function () {
        $btn.removeClass('hk-loading');
        // Refresh cart drawer content
fetch('/?section_id=cart-drawer')
  .then((response) => response.text())
  .then((html) => {
    const parser = new DOMParser();
    const newDoc = parser.parseFromString(html, 'text/html');

    const newDrawer = newDoc.querySelector('cart-drawer');
    const currentDrawer = document.querySelector('cart-drawer');

    if (newDrawer && currentDrawer) {
      currentDrawer.innerHTML = newDrawer.innerHTML;
    }

    // Open drawer after refresh
    document.querySelector('cart-drawer.drawer')?.classList.remove('is-empty');
    currentDrawer?.open();
  });
        hkCheckSubInCart();   // re-check cart & re-apply price rule
      }, 500);
    }
  });

});


$(document).on('click', '.hk-pdp-input-plus', function () {
    var $input = $('.hk-pdp-input');
    var $minus = $('.hk-pdp-input-minus');

    var value = parseInt($input.val() || 1, 10);
    value++;

    $input.val(value);

    if (value > 1) {
        $minus.prop('disabled', false);
    }
});

$(document).on('click', '.hk-pdp-input-minus', function () {
    var $input = $('.hk-pdp-input');
    var $minus = $('.hk-pdp-input-minus');

    var value = parseInt($input.val() || 1, 10);

    if (value > 1) {
        value--;
        $input.val(value);
    }

    if (value <= 1) {
        $minus.prop('disabled', true);
        $input.val(1);
    }
});




$(document).on("click", "a[href='#bundle_atc']", function (e) {
  e.preventDefault();
var $btn = $(this);
  // prevent multiple clicks
  if ($btn.hasClass('hk-loading')) return;

  $btn.addClass('hk-loading');
  var items = [];
  // main product


  $('.hk-video-list1-item:not(.hk-free-bundle-item)').each(function(){
 var variant_id = $(this).attr('variant_id');
  var item = {
    id: parseInt(variant_id),
    quantity: 1
  };
  items.push(item);
  });

  // subscription (only if checked) — added once
  var subItem = hkGetSubItem();
  if (subItem) items.push(subItem);

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({
      items: items
    }),
    dataType: 'json',
    contentType: 'application/json',

    success: function () {

    },

    complete: function () {
      setTimeout(function () {
        $btn.removeClass('hk-loading');
        // Refresh cart drawer content
fetch('/?section_id=cart-drawer')
  .then((response) => response.text())
  .then((html) => {
    const parser = new DOMParser();
    const newDoc = parser.parseFromString(html, 'text/html');

    const newDrawer = newDoc.querySelector('cart-drawer');
    const currentDrawer = document.querySelector('cart-drawer');

    if (newDrawer && currentDrawer) {
      currentDrawer.innerHTML = newDrawer.innerHTML;
    }

    // Open drawer after refresh
    document.querySelector('cart-drawer.drawer')?.classList.remove('is-empty');
    currentDrawer?.open();
  });
        hkCheckSubInCart();   // re-check cart & re-apply price rule
      }, 500);
    }
  });
});




$(document).on("click", "a.hk-search-icon", function (e) {
  e.preventDefault();
 $('.hk-header details-modal.header__search summary.header__icon').trigger('click');
});


// ================= Subscription: price toggle + helper =================

var HK_SUB_VARIANT = null;      // subscription variant id (from the toggle)
var HK_SUB_IN_CART = false;     // updated from /cart.js

// read the subscription variant id off the toggle
function hkSubVariantId() {
  var $sub = $('.hk-element-sub-option').first();
  if (!$sub.length) return null;
  var v = parseInt($sub.attr('variant_id'), 10);
  return v || null;
}

// is the checkbox currently checked?
function hkSubIsChecked() {
  return $('.hk-element-sub-option').hasClass('hk-active');
}

// returns the subscription line item, or null if not checked
function hkGetSubItem() {
  var $sub = $('.hk-element-sub-option.hk-active').first();
  if (!$sub.length) return null;

  var vid = parseInt($sub.attr('variant_id'), 10);
  if (!vid) return null;

  var item = { id: vid, quantity: 1 };
  var plan = $sub.attr('selling_plan');
  if (plan && plan !== 'null' && plan !== '') {
    item.selling_plan = parseInt(plan, 10);
  }
  return item;
}

// show discounted if checkbox checked OR subscription already in cart
function hkShouldShowDiscounted() {
  return hkSubIsChecked() || HK_SUB_IN_CART;
}

// swap every price element between original / discounted
function hkSetPrices(showDiscounted) {
  $('[data-original][data-discounted]').each(function () {
    var $el = $(this);
    var val = showDiscounted ? $el.attr('data-discounted') : $el.attr('data-original');
    var $val = $el.find('.hk-price-value').first();
    if ($val.length) {
      $val.text(val);
    } else if ($el.hasClass('hk-price-value')) {
      $el.text(val);
    }
  });
}

// switch the main-product price tab: 1 = discounted/VIP, 2 = original
function hkSetSubTab(showDiscounted) {
  var tab = showDiscounted ? '1' : '2';
  $('.hk-sub-trigger').hide().removeClass('hk-active');
  $('.hk-sub-trigger[sub_tab="' + tab + '"]').show().addClass('hk-active');
}

// recompute the rule and apply (upsell/bundle prices + main-product tab)
function hkRefreshPrices() {
  var showDiscounted = hkShouldShowDiscounted();
  hkSetPrices(showDiscounted);
  hkSetSubTab(showDiscounted);
}

// check the cart for the subscription variant, then refresh prices
function hkCheckSubInCart() {
  HK_SUB_VARIANT = hkSubVariantId();
  if (!HK_SUB_VARIANT) { hkRefreshPrices(); return; }

  $.getJSON('/cart.js', function (cart) {
    HK_SUB_IN_CART = false;
    (cart.items || []).forEach(function (line) {
      if (line.variant_id === HK_SUB_VARIANT) HK_SUB_IN_CART = true;
    });
    hkRefreshPrices();
  }).fail(function () {
    hkRefreshPrices();  // if cart check fails, fall back to checkbox only
  });
}

// Re-check the cart whenever the cart drawer changes (add OR remove).
// This clears the stale HK_SUB_IN_CART flag when the subscription is removed,
// so the toggle can change the price again without a page refresh.
$(function () {
  var pending = null;
  function scheduleRecheck() {
    clearTimeout(pending);
    pending = setTimeout(hkCheckSubInCart, 300);  // debounce burst of mutations
  }

  // Observe the whole body subtree for any cart-drawer changes. Watching body
  // (not the drawer node itself) survives Shopify replacing the drawer element
  // wholesale during its section re-render.
  if (window.MutationObserver) {
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (t && t.closest && t.closest('cart-drawer')) { scheduleRecheck(); return; }
        // also catch the drawer node itself being added/removed
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType === 1 && (n.matches && (n.matches('cart-drawer') || n.querySelector('cart-drawer')))) {
            scheduleRecheck(); return;
          }
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }
});

// Re-check whenever a remove/quantity control is clicked in the drawer,
// as a belt-and-braces fallback to the observer above.
$(document).on('click',
  'cart-drawer .cart-remove-button, cart-drawer [name="minus"], cart-drawer [name="plus"], cart-drawer a[href*="/cart/change"], .cart-remove-button',
  function () {
    setTimeout(hkCheckSubInCart, 700);  // after Shopify updates the cart
  }
);

// on load: check cart, then set prices per the rule
$(function () {
  hkCheckSubInCart();
});
/* ============================================================
   HK DYNAMIC PRICE
   Append to the BOTTOM of assets/hk_pdp.js — change nothing above.

   Works whether or not the product has a variant selector:
     - With variants    → .custom-variant-option (or .hk-element-variant)
     - Without variants → falls back to default_variant_id from the JSON

   Depends on formatMoney(cents, format, hideZeroCents) from main.js.
   ============================================================ */

var HK_PRICE_DATA = null;
var HK_ACTIVE_VARIANT_ID = null;

/* Both markup styles supported. */
var HK_VARIANT_SELECTOR = '.custom-variant-option, .hk-element-variant';
var HK_ACTIVE_SELECTOR = '.custom-variant-option.is-active, .hk-element-variant.hk-active';

/* ---------------- Data ---------------- */

function hkReadPriceData() {
  var node = document.querySelector('[data-hk-price-data]');
  if (!node) return null;
  try {
    return JSON.parse(node.textContent);
  } catch (e) {
    console.error('[HK] price data parse failed:', e);
    return null;
  }
}

function hkVariantIdOf(el) {
  if (!el) return null;
  return el.getAttribute('data-variant-id') || el.getAttribute('variant_id');
}

function hkFindVariant(id) {
  if (!HK_PRICE_DATA || !id) return null;
  id = parseInt(id, 10);
  for (var i = 0; i < HK_PRICE_DATA.variants.length; i++) {
    if (HK_PRICE_DATA.variants[i].id === id) return HK_PRICE_DATA.variants[i];
  }
  return null;
}

/* ---------------- Money ---------------- */

function hkMoney(cents, hideZeroCents) {
  if (typeof formatMoney === 'function' && HK_PRICE_DATA && HK_PRICE_DATA.money_format) {
    return formatMoney(cents, HK_PRICE_DATA.money_format, !!hideZeroCents);
  }
  return '$' + (cents / 100).toFixed(2);
}

/* ---------------- Price maths ---------------- */

function hkComputeStates(variant) {
  var pct = parseFloat(HK_PRICE_DATA.discount_percent) || 0;
  var vipCompare = parseInt(HK_PRICE_DATA.vip.compare_at_price, 10) || 0;

  var price = parseInt(variant.price, 10) || 0;
  var compareAt = parseInt(variant.compare_at_price, 10) || 0;
  var compare = compareAt > price ? compareAt : price;

  /* One-time */
  var regular = {
    price: price,
    compare: compare,
    save: compare > price ? Math.round((compare - price) * 100 / compare) : 0
  };

  /* Subscription: discount off price, VIP cost added to compare */
  var subPrice = price - Math.round(price * pct / 100);
  var subCompare = compare + vipCompare;

  var sub = {
    price: subPrice,
    compare: subCompare,
    save: subCompare > subPrice ? Math.round((subCompare - subPrice) * 100 / subCompare) : 0
  };

  return { regular: regular, sub: sub };
}

/* ---------------- Rendering ---------------- */

function hkRenderTab(tabEl, state) {
  if (!tabEl) return;

  var priceEl = tabEl.querySelector('[data-hk-price]');
  var compareEl = tabEl.querySelector('[data-hk-compare]');
  var saveEl = tabEl.querySelector('[data-hk-save]');
  var savePctEl = tabEl.querySelector('[data-hk-save-pct]');

  if (priceEl) priceEl.textContent = hkMoney(state.price, true);

  var showCompare = state.compare > state.price;

  if (compareEl) {
    compareEl.textContent = hkMoney(state.compare, false);
    compareEl.hidden = !showCompare;
  }
  if (saveEl) saveEl.hidden = !showCompare;
  if (savePctEl) savePctEl.textContent = state.save;
}

function hkRenderPrices() {
  if (!HK_PRICE_DATA) return;

  var variant = hkFindVariant(HK_ACTIVE_VARIANT_ID)
    || hkFindVariant(HK_PRICE_DATA.default_variant_id)
    || HK_PRICE_DATA.variants[0];

  if (!variant) return;

  var states = hkComputeStates(variant);

  document.querySelectorAll('[data-hk-price-block]').forEach(function (block) {
    hkRenderTab(block.querySelector('.hk-sub-trigger[sub_tab="1"]'), states.sub);
    hkRenderTab(block.querySelector('.hk-sub-trigger[sub_tab="2"]'), states.regular);
  });
}

/* Keep the ATC button pointing at the selected variant. */
function hkSyncAtcVariant() {
  if (!HK_ACTIVE_VARIANT_ID) return;

  document.querySelectorAll('.hk-atc-js').forEach(function (btn) {
    if (btn.closest('.hk-element-product-item, .hk-video-list1-item, .hk-element-products-bundle, .hk-free-bundle-item')) return;
    btn.setAttribute('variant_id', HK_ACTIVE_VARIANT_ID);
  });
}

/* ---------------- Variant selection ---------------- */

$(document).on('click', HK_VARIANT_SELECTOR, function (e) {
  e.preventDefault();

  var btn = this;
  var variantId = hkVariantIdOf(btn);
  if (!variantId) return;

  var scope = btn.closest('.custom-variant-block')
    || btn.closest('.hk-product')
    || document;

  scope.querySelectorAll(HK_VARIANT_SELECTOR).forEach(function (el) {
    el.classList.remove('is-active', 'hk-active');
    el.setAttribute('aria-selected', 'false');
  });

  btn.classList.add(btn.classList.contains('hk-element-variant') ? 'hk-active' : 'is-active');
  btn.setAttribute('aria-selected', 'true');

  /* Keep the "Variants: X" header label in sync. */
  var title = btn.getAttribute('data-variant-title') || btn.textContent.trim();
  var current = scope.querySelector('[data-current-variant-title]');
  if (current) {
    current.textContent = title;
    current.setAttribute('title', title);
  }

  HK_ACTIVE_VARIANT_ID = parseInt(variantId, 10);

  hkSyncAtcVariant();
  hkRenderPrices();
});

/* ---------------- Init ---------------- */

$(function () {
  HK_PRICE_DATA = hkReadPriceData();
  if (!HK_PRICE_DATA) return;

  /* No selector on the page (single-variant product) → use the default. */
  var active = document.querySelector(HK_ACTIVE_SELECTOR);

  HK_ACTIVE_VARIANT_ID = active
    ? parseInt(hkVariantIdOf(active), 10)
    : HK_PRICE_DATA.default_variant_id;

  hkSyncAtcVariant();
  hkRenderPrices();
});

/* ---------------- Header cart count ---------------- */

function hkUpdateCartCount() {
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('.hk-cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    })
    .catch(function () {});
}

$(function () {
  hkUpdateCartCount();

  var drawer = document.querySelector('cart-drawer');
  if (!drawer || !window.MutationObserver) return;

  var timer = null;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(hkUpdateCartCount, 250);
  }).observe(drawer, { childList: true, subtree: true });
});